Controller.$inject = [];

function Controller() {

}

export function HuiPageTitle() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return ` <h1 class="hui hui-page-title fs-8" ng-transclude></h1>`;
        }
    };
}